import { flare } from "@flareapp/flare-client";
flare.light(process.env.FLARE_JS_KEY);
